import { createStore, combineReducers } from "redux";

import { composeWithDevTools } from 'redux-devtools-extension';

import layoutInputReducer, { LayoutInputState } from "./reducers/LayoutInputReducer";
import layoutOutputReducer, { LayoutOutputState } from "./reducers/LayoutOutputReducer";


const rootReducer = combineReducers({
  input: layoutInputReducer,
  output: layoutOutputReducer
});

//export type RootState = ReturnType<typeof rootReducer>

export interface RootState { 
  input: LayoutInputState,
  output: LayoutOutputState
}

//const store: Store<RootState> = createStore(
//  rootReducer as any,
//  // initialState,
//  (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
//);


const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
const store = createStore(rootReducer, composeEnhancers(
  //applyMiddleware(invariant(), thunk)
));

export default store;
